export const getCommonKeys = (arr) => {
  const keysCount = {};

  arr.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      keysCount[key] = (keysCount[key] || 0) + 1;
    });
  });

  const commonKeys = Object.keys(keysCount).filter(
    (key) => keysCount[key] === 1 || keysCount[key] > 1
  );

  const keysObj = {};
  commonKeys.map((key, i) => {
    return (keysObj[key] = i);
  });

  return keysObj;
};

export const alertsConfig = (data) => {
  const tickerTypesCount = {};

  data.forEach((item) => {
    const { ticker, type } = item;

    if (!tickerTypesCount[ticker]) {
      tickerTypesCount[ticker] = {};
    }

    if (!tickerTypesCount[ticker][type]) {
      tickerTypesCount[ticker][type] = 1;
    } else {
      tickerTypesCount[ticker][type]++;
    }
  });

  const result = [];

  for (const ticker in tickerTypesCount) {
    const types = tickerTypesCount[ticker];
    const typeKeys = Object.keys(types);
    if (typeKeys.length > 0) {
      const formattedTypes = {};
      typeKeys.forEach((key) => {
        formattedTypes[key] = types[key];
      });

      let counts = 0;

      Object.keys(formattedTypes).map((key) => {
        if (counts === 0) {
          counts = formattedTypes[key];
        } else {
          counts = counts + formattedTypes[key];
        }
        return counts;
      });

      result.push({
        ticker: ticker,
        types: formattedTypes,
        appearence: counts,
      });
    }
  }

  return result;
};
